import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

export const DocumentationPage = () => {
  useEffect(() => {
    window.location.href = 'https://nas-academy.gitbook.io/nas-io/';
  });
  return (
    <>
      <Helmet>
        <title>Nas IO Documentation</title>
        <meta name="title" content="Nas IO Documentation" />
        <meta
          name="description"
          content="Empowering Education using Web3/Blockchain technology. We are the technology arm of Nas Academy, whose mission is to create the world's best learning communities."
        />
        <meta
          property="og:image"
          content="https://s3.ap-southeast-1.amazonaws.com/image-assets.nasdaily.com/lesan/nasio/nasio_cover.png"
        />
        <meta
          property="og:url"
          content={`${process.env.REACT_APP_FRONTEND_URL}/documentation`}
        />
      </Helmet>
    </>
  );
};
